// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1bEsE","title":"AfterFrontImage_title__FKX2u"};